<script>
export default {
    name: 'StickyTop',
    data() {
        return {
            // Add a bottom border when the user scrolls down to better distinguish the sticky div.
            showStickyDivBottomBorder: false
        };
    },
    computed: {
        /**
         * Get the classes for the sticky div.
         * @return {String} - The classes for the sticky div.
         */
        stickyDivClasses() {
            let classes = this.$q.screen.lt.sm
                ? 'sticky-top-mobile'
                : 'sticky-top';

            if (this.showStickyDivBottomBorder) {
                classes += ' sticky-top--border';
            }
            return classes;
        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        /**
         * Handles the scroll event.
         */
        handleScroll() {
            this.onScroll(window.scrollY);
        },
        /**
         * Executed when the user scrolls.
         * @param {Number} position - The position of the scroll.
         */
        onScroll(position) {
            this.showStickyDivBottomBorder = position >= 75;
        }
    }
};
</script>
